export const blockIconsActionCheckCircle = (
	<span className='material-symbols-outlined'>check_circle</span>
);
